<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: function() {
        return [];
      }
    },
    tabsTextStyle: {
      type: String
    },
    setActiveTab: {
      type: Number
    },
    isList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: 0,
      showItems: false
    };
  },

  methods: {
    clickTab(idx) {
      jQuery('[data-toggle="tooltip"]').tooltip("hide");
      this.activeTab = idx;
      this.$emit("onClickTab", idx);

      this.showItems = false;
    }
  },

  watch: {
    setActiveTab: function() {
      this.activeTab = this.setActiveTab;
    }
  },

  mounted() {
    if (this.setActiveTab) this.activeTab = this.setActiveTab;

    this.$nextTick(function() {
      jQuery('[data-toggle="tooltip"]').tooltip();
    });
  },

  created() {}
};
</script>

<template>
  <div class="w-100">
    <!-- Visualização DESKTOP-->
    <!-- LISTA -->
    <div class="w-100 d-none d-md-block default-container" v-if="isList">
      <ul class="nav-tabs list-group">
        <li
          v-if="!tab.hidden"
          class="nav-item text-center"
          v-for="(tab, index) in tabs"
          :key="index"
          data-toggle="tooltip"
          data-placement="top"
          :title="tab.help"
        >
          <a
            v-if="!tab.title"
            class="nav-link"
            href="javascript:void(0)"
            @click="clickTab(index)"
            :class="{ active: activeTab === index }"
          >
            <i
              v-if="tab.icon"
              class="icon-tab fa"
              :class="tab.icon"
              aria-hidden="true"
            ></i>
            <span v-if="tab.count" class="counter"> {{ tab.count }} </span>
          </a>
          <a
            v-if="tab.title"
            class="nav-link position-relative"
            style="padding: 10px"
            href="javascript:void(0)"
            @click="clickTab(index)"
            :class="{ active: activeTab === index }"
          >
            <i
              v-if="tab.icon"
              class="icon-tab fa"
              :class="tab.icon"
              aria-hidden="true"
            ></i>
            <span v-if="tab.count" class="counter position-absolute">
              {{ tab.count }}
            </span>
            <br />
            <span :style="tabsTextStyle"> {{ tab.title }} </span>
          </a>
        </li>
      </ul>
    </div>
    <div class="w-100 d-none d-md-block" v-else>
      <ul class="nav nav-tabs">
        <li
          v-if="!tab.hidden"
          class="nav-item text-center"
          v-for="(tab, index) in tabs"
          :key="index"
          data-toggle="tooltip"
          data-placement="top"
          :title="tab.help"
        >
          <a
            v-if="!tab.title"
            class="nav-link"
            href="javascript:void(0)"
            @click="clickTab(index)"
            :class="{ active: activeTab === index }"
          >
            <i
              v-if="tab.icon"
              class="icon-tab fa"
              :class="tab.icon"
              aria-hidden="true"
            ></i>
            <span v-if="tab.count" class="counter"> {{ tab.count }} </span>
          </a>
          <a
            v-if="tab.title"
            class="nav-link position-relative"
            href="javascript:void(0)"
            @click="clickTab(index)"
            :class="{ active: activeTab === index }"
          >
            <i
              v-if="tab.icon"
              class="icon-tab fa"
              :class="tab.icon"
              aria-hidden="true"
            ></i>
            <span v-if="tab.count" class="counter position-absolute">
              {{ tab.count }}
            </span>
            <br />
            <span :style="tabsTextStyle"> {{ tab.title }} </span>
          </a>
        </li>
      </ul>
    </div>
    <!-- Visualização Mobile-->
    <div class="w-100 d-block d-md-none">
      <ul
        class="nav-tabs p-0 w-100 animation-height "
        :class="!showItems ? 'max-height' : 'no-max-height'"
        style="list-style-type: none;"
      >
        <li
          v-if="!tab.hidden"
          class="nav-item nav-link-mobile text-center d-flex w-100 "
          v-for="(tab, index) in tabs"
          :key="index"
          data-toggle="tooltip"
          data-placement="top"
          :title="tab.help"
        >
          <a
            v-if="!tab.title && activeTab === index"
            class="nav-link nav-link-mobile w-100 d-flex align-items-center py-3"
            href="javascript:void(0)"
            @click="clickTab(index)"
            :class="{ active: activeTab === index }"
          >
            <i
              v-if="tab.icon"
              class="icon-tab fa col-2"
              :class="tab.icon"
              aria-hidden="true"
            ></i>
            <span v-if="tab.count" class="counter col-auto">
              {{ tab.count }}
            </span>
            <i v-if="tab.count" class="counter col-auto fa fa-angle-down">
              {{ tab.count }}
            </i>
          </a>
          <a
            v-if="tab.title && showItems"
            class="nav-link nav-link-mobile position-relative w-100 d-flex align-items-center justify-content-start shaddow py-3 position-relative"
            href="javascript:void(0)"
            @click="clickTab(index)"
            :class="{ active: activeTab === index }"
          >
            <i
              v-if="tab.icon"
              class="col-2 icon-tab fa"
              :class="tab.icon"
              aria-hidden="true"
            ></i>
            <span v-if="tab.count" class="col-auto counter position-absolute">
              {{ tab.count }}
            </span>
            <br />
            <span :style="tabsTextStyle"> {{ tab.title }} </span>
            <i
              v-if="index == 0"
              class=" fa position-absolute right-0"
              :class="showItems ? 'fa-angle-up' : 'fa-angle-down'"
              style="right:20px; font-size: 20px;"
              @click.stop="showItems = false"
            >
              {{ tab.count }}
            </i>
          </a>
          <a
            @click="showItems = true"
            v-if="tab.title && !showItems && activeTab === index"
            class="nav-link nav-link-mobile position-relative w-100 d-flex align-items-center justify-content-start shaddow py-3 position-relative"
            href="javascript:void(0)"
            :class="{ active: activeTab === index }"
          >
            <i
              v-if="tab.icon"
              class="col-2 icon-tab fa"
              :class="tab.icon"
              aria-hidden="true"
            ></i>
            <span v-if="tab.count" class="col-auto counter position-absolute">
              {{ tab.count }}
            </span>
            <br />
            <span :style="tabsTextStyle"> {{ tab.title }} </span>
            <i
              class=" fa position-absolute right-0"
              :class="showItems ? 'fa-angle-up' : 'fa-angle-down'"
              style="right:20px; font-size: 20px;"
            >
              {{ tab.count }}
            </i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.icon-tab {
  font-size: 20px;
  /* padding-right: 8px; */
}

.counter {
  top: 20px;
  right: 5px;
}

.nav-link-mobile.active {
  border-left: 3px solid #1161bc;
  border-bottom: 1px #e5e5e5 !important;
}

.nav-link-mobile {
  border-left: 3px solid transparent;
  border-bottom: 1px #e5e5e5 !important;
}

.nav-tabs {
  overflow-y: hidden;
}
.animation-height {
  transition: all;
  transition-duration: 0.5s;
}
.max-height {
  max-height: 54px;
}
.no-max-height {
  max-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/tabs.vue